export enum CreateProductFormStateKeys {
  REQUIREMENT_ITEMS = 'items',
  TEST_CASES = 'testCases',
}
